export default __webpack_public_path__ + "static/media/md-logo-vr.d9b47fe2.svg";